
import React, { useState, useEffect } from 'react';
import { ApolloProvider } from '@apollo/client';
import { GraphQlGuestClient } from '../apolloGuestClient';
import { ManagerApproval } from './ManagerApproval';

function parseLinkParams() {
    try {
        const url = new URL(window.location.href);
        const rq = url.searchParams.get('r') || url.searchParams.get('requestId');
        const t = url.searchParams.get('t') || url.searchParams.get('token');
        const r = rq != null ? parseInt(rq, 10) : null;
        return { requestId: Number.isFinite(r) ? r : null, token: t || null };
    } catch {
        return { requestId: null, token: null };
    }
}

export const GuestManagerApprovalGate = () => {
	
    const { requestId, token } = parseLinkParams();
    const client = GraphQlGuestClient(token || '');

    return (
	
        <>
            {!token || requestId == null ? (
                <p>Invalid link: missing request id or token.</p>
            ) : (
                <ApolloProvider client={client}>
                    <main>
						
                    <div style={{ marginTop: "60px", marginLeft: "0", marginRight: "0" }}>
                        <ManagerApproval />
                    </div>
					</main>
                </ApolloProvider>
            )}
        </>
		
    );
};
